var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.88483 11.7C7.7167 11.7002 7.55024 11.6579 7.39491 11.5755C7.23964 11.4931 7.09859 11.3722 6.97987 11.2198L0.57969 3.02587C0.460846 2.87372 0.366574 2.69308 0.302256 2.49428C0.237938 2.29549 0.204834 2.08242 0.204834 1.86724C0.204834 1.65207 0.237938 1.439 0.302256 1.2402C0.366574 1.0414 0.460846 0.860772 0.57969 0.708617C0.698532 0.556464 0.83962 0.43577 0.994897 0.353425C1.15018 0.27108 1.3166 0.228699 1.48468 0.228699C1.65275 0.228699 1.81917 0.27108 1.97445 0.353425C2.12973 0.43577 2.27081 0.556464 2.38965 0.708617L7.88483 7.74395L13.38 0.708617C13.4988 0.556464 13.64 0.43577 13.7952 0.353425C13.9505 0.27108 14.1169 0.228699 14.285 0.228699C14.4531 0.228699 14.6195 0.27108 14.7747 0.353425C14.93 0.43577 15.0711 0.556464 15.19 0.708616C15.3088 0.860772 15.4031 1.0414 15.4674 1.2402C15.5317 1.439 15.5648 1.65207 15.5648 1.86724C15.5648 2.08242 15.5317 2.29549 15.4674 2.49428C15.4031 2.69308 15.3088 2.87372 15.19 3.02587L8.78979 11.2198C8.67113 11.3722 8.53008 11.4931 8.37475 11.5755C8.21942 11.6579 8.05296 11.7002 7.88483 11.7Z",
    fill: "#495E57"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.07633d47731da19af60a9e8073a24db7.svg";
export { ForwardRef as ReactComponent };